module.exports = __webpack_public_path__ + "static/media/LIGHTING_RGB.57e991ae.png";